import type { PlateEditor } from '@udecode/plate-common/react';
import { getBlockAbove, getNextNode, insertNodes, replaceNode, withoutNormalizing } from '@udecode/plate-common';
import { Path } from 'slate';

import { OVERRIDE_PLUGINS } from '@/component/customEditorV2/useCreateEditor';
import { VideoPlugin } from '@/component/customEditorV2/plugins/custom/videoPlugin';
import { DocumentPlugin } from '@/component/customEditorV2/plugins/custom/documentPlugin';
import { QuizQuestionPlugin } from '@/component/customEditorV2/plugins/custom/quizQuestionPlugin';
import { ImagePlugin } from '@/component/customEditorV2/plugins/custom/imagePlugin';
import { AudioPlugin } from '@/component/customEditorV2/plugins/custom/audioPlugin';
import { EmbeddedDocumentPlugin } from '@/component/customEditorV2/plugins/custom/embeddedDocumentPlugin';

const insertBlockMap: Record<string, (editor: PlateEditor, type: string) => void> = {};

export const ELEMENTS_WITH_MANDATORY_EMPTY_LINE_AFTER: string[] = [
  VideoPlugin.key,
  EmbeddedDocumentPlugin.key,
  AudioPlugin.key,
  DocumentPlugin.key,
  QuizQuestionPlugin.key,
  ImagePlugin.key,
];

export const insertBlock = (editor: PlateEditor, type: string): void => {
  const customType = OVERRIDE_PLUGINS[type as keyof typeof OVERRIDE_PLUGINS]?.node?.type || type;

  withoutNormalizing(editor, () => {
    if (type in insertBlockMap) {
      insertBlockMap[type](editor, type);
    } else {
      const path = getBlockAbove(editor)?.[1];

      if (!path) return;

      replaceNode(editor, {
        at: path,
        insertOptions: { select: true },
        nodes: editor.api.create.block({ type: customType }),
        removeOptions: {},
      });

      const hasNextNode = !!getNextNode(editor, { at: path });

      if (ELEMENTS_WITH_MANDATORY_EMPTY_LINE_AFTER.includes(customType) && !hasNextNode) {
        insertNodes(editor, { type: 'paragraph', children: [{ text: '' }] }, { at: Path.next(path) });
      }
    }
  });
};
